import {regulatedCompaniesEnum} from "../enums/regulated-companies";
import {getCookie, hasCookie, setCookie} from "./cookies";

export const hasCNMV = (regulatedCompanies) => regulatedCompanies && regulatedCompanies.length > 0 && regulatedCompanies.includes(regulatedCompaniesEnum.DX_CNMV);

export const isEUGroup = (regulatedCompanies) => regulatedCompanies && regulatedCompanies.length > 0 && regulatedCompanies.includes(regulatedCompaniesEnum.DX_FCA) && regulatedCompanies.includes(regulatedCompaniesEnum.DX_CNMV) && regulatedCompanies.includes(regulatedCompaniesEnum.DX_SYC);

export const isEUGroupSelected = (regulatedCompanies, regulatedCompany) => isEUGroup(regulatedCompanies) && regulatedCompany === regulatedCompaniesEnum.DX_SYC;

export const setCountryAndRegulatedCompany = ({
    event,
    regulatedCompanyNavigation,
    regulatedCompany,
    registerCountries,
    countryByIp,
    lang,
}) => {

    let registerCountry = null;
    let newRegulatedCompany = regulatedCompanyNavigation;
    let regulatedCompanies = [];

    if (event) {
        event.preventDefault();
        registerCountry = event.target.value;
        newRegulatedCompany = regulatedCompany;
    }

    if (!registerCountry) {
        if (countryByIp && typeof registerCountries.find(c => c.id == countryByIp) !== 'undefined') {
            registerCountry = countryByIp;
        } else {
            switch (lang) {
                case 'zh':
                    registerCountry = 'CN';
                    break;
                case 'fr':
                    registerCountry = 'FR';
                    break;
                case 'es':
                    registerCountry = 'ES';
                    break;
                case 'it':
                    registerCountry = 'IT';
                    break;
                case 'cs':
                    registerCountry = 'CZ';
                    break;
                case 'de':
                    registerCountry = 'DE';
                    break;
                case 'en':
                    registerCountry = 'GB';
                    break;
                default:
                    registerCountry = 'GB';
            }
        }
    }

    const registerCountrySelected = registerCountries.find(c => c.id == registerCountry);
    if (registerCountrySelected.regulatedCompanies && registerCountrySelected.regulatedCompanies.length > 0) {
        regulatedCompanies = registerCountrySelected.regulatedCompanies;
        const defaultRegulatedCompany = registerCountrySelected.regulatedCompanies[0];
        if (newRegulatedCompany === '') {
            newRegulatedCompany = defaultRegulatedCompany;
        } else {
            newRegulatedCompany = registerCountrySelected.regulatedCompanies.includes(newRegulatedCompany) ? newRegulatedCompany : defaultRegulatedCompany;
        }
    } else {
        regulatedCompanies = [];
        newRegulatedCompany = '';
    }

    return {
        newRegulatedCompany,
        regulatedCompanies,
        registerCountry,
    }
}

export const setRegisterTypeCookie = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.get('dx_register_type')) {
        const registerType = encodeURIComponent(urlParams.get('dx_register_type'));
        setCookie('dx_register_type', registerType, 30);
        return registerType;
    }
    return null;
};

export const getRegisterType = () => {
    return setRegisterTypeCookie() || (hasCookie('dx_register_type') ? encodeURIComponent(getCookie('dx_register_type')) : null);
};
